<template>
  <div>
    <b-overlay
      class="lp-container"
      :show="loading"
      variant="transparent"
      rounded="sm"
    />
    <PaymentFailed v-if="!loading && !paymentStatus" />
    <PaymentSuccessful v-if="!loading && paymentStatus" />
  </div>
</template>

<script>
import PaymentFailed from '@/components/Lp/PaymentFailed.vue'
import PaymentSuccessful from '@/components/Lp/PaymentSuccessful.vue'
import { BOverlay } from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { showNotify, throwPaymentError } from '@/helpers/helpers'
import moment from 'moment'

export default {
  name: 'LpsPaymentFinalize',
  components: {
    BOverlay,
    PaymentFailed,
    PaymentSuccessful,
  },
  data() {
    return {
      loading: false,
      paymentStatus: false,
      ykbPosInfoFromServerKey: process.env.VUE_APP_YKB_POS_INFO_FROM_SERVER_KEY,
    }
  },
  created() {
    try {
      const lpPaymentSuccessfulTime = localStorage.getItem('LP_PAYMENT_SUCCESSFUL_TIME') || null

      // eslint-disable-next-line radix
      if (lpPaymentSuccessfulTime && moment(parseInt(lpPaymentSuccessfulTime)).isAfter(moment().unix())) {
        this.loading = false
        this.paymentStatus = true
      } else {
        const base64Code = this.$route.query.c
        // eslint-disable-next-line no-buffer-constructor
        const buff = new Buffer(base64Code, 'base64')
        const posnetData = JSON.parse(buff.toString('utf8'))

        if (!posnetData || !localStorage.getItem('LAST_PAYMENT_TRANSACTION_ID_KEY')) {
          this.loading = false
          this.paymentStatus = false
        } else if (posnetData) {
          const transaction = {
            merchantPacket: posnetData.MerchantPacket,
            bankPacket: posnetData.BankPacket,
            sign: posnetData.Sign,
            ccPrefix: posnetData.CCPrefix,
            tranType: posnetData.TranType,
            purchaseSource: 'lps',
          }

          this.loading = true

          useJwt.paymentPostnetPerform(transaction)
            .then(response => {
              const paymentStatus = response.data.body

              if (paymentStatus.approved) {
                localStorage.removeItem('LAST_PAYMENT_TRANSACTION_ID_KEY')
                localStorage.removeItem('LAST_PAYMENT_AMOUNT')

                gtag(
                  'event',
                  'conversion',
                  {
                    send_to: 'AW-805828651/SYhYCObUj60aEKvwn4AD',
                    value: parseFloat(localStorage.getItem('LAST_PAYMENT_AMOUNT')),
                    currency: 'TRY',
                    transaction_id: localStorage.getItem('LAST_PAYMENT_TRANSACTION_ID_KEY'),
                  },
                )

                this.loading = false
                this.paymentStatus = true

                localStorage.setItem('LP_PAYMENT_SUCCESSFUL_TIME', moment().add('3', 'minute').unix().toString())

                this.lpUserAction('payment-successful')
              } else {
                showNotify(this.$toast, this.$t('An error occurred during the payment process. Please try again.'), 'danger')
                this.lpUserAction()
                this.loading = false
                this.paymentStatus = false
              }
            })
            .catch(error => {
              throwPaymentError(this.$toast, error)
              this.lpUserAction()
              this.loading = false
              this.paymentStatus = false
            })
        } else {
          showNotify(this.$toast, this.$t('An error occurred during the payment process. Please try again.'), 'danger')
          this.lpUserAction()
          this.loading = false
          this.paymentStatus = false
        }
      }
    } catch (e) {
      throwPaymentError(this.$toast, e)
      this.lpUserAction()
      this.loading = false
      this.paymentStatus = false
    }
  },
  methods: {
    lpUserAction(action = 'payment-failed', subData = null) {
      // eslint-disable-next-line no-underscore-dangle
      const _data = {}

      if (subData) {
        Object.assign(_data, { data: subData })
      }

      const data = {
        flow: 'lp-1',
        action,
        data: JSON.stringify(_data),
        deviceId: this.$store.getters['app/deviceId'],
      }

      useJwt.lpUserAction(data)
    },
  },
}
</script>
